<template>
  <header>
    <div class="bgheader">
      <nav class="d-flex flex-row justify-start align-center py-2 px-8">
        <v-flex
          xs3
          class="d-none d-sm-flex flex-row px-2 flex-shrink-0"
        >
          <div class="logoSize">
            <input
              type="image"
              :src="electionLogo"
              class="logoSize"
              title="Logotipo da eleição"
              v-if="electionLogo"
            />
          </div>
        </v-flex>
        <v-flex
          xs12
          sm6
          class="d-flex flex-row px-2 flex-shrink-0 align-items-center justify-center"
        >
          <h1 :class="$vuetify.theme.dark ? 'font_dark' : 'font_white'">
            {{ this.$store.state.election.name }}
            <span class="voterNameMenu">{{
              $store.state.login.voterName
                ? ' - ' + $store.state.login.voterName
                : ''
            }}</span>
          </h1>
        </v-flex>
        <v-flex
          class="d-flex align-items-center justify-start"
          v-if="isAuthenticated && !isAuthenticated"
        >
          <div
            class="d-flex align-items-center px-2"
            v-for="(item, i) in items"
            :key="i"
          >
            <a
              :href="item.to"
              class="d-flex flex-column align-items-center justify-start px-2 secondary--text"
            >
              <v-icon
                v-text="item.icon"
                class="white--text"
              />
              <span class="white--text">{{ item.title }}</span>
            </a>
          </div>
          <div
            class="d-flex
            align-items-center
            justify-center
            px-2"
          >
            <p class="secondary--text px-2 ma-0">
              {{ $store.state.login.voterName }}
            </p>
            <v-btn
              elevation="0"
              class="error"
              @click="logout"
            >
              <span class="white--text">Sair</span>
            </v-btn>
          </div>
        </v-flex>
        <v-flex
          xs3
          v-if="accessibilityActivated"
          class="d-none d-sm-flex flex-row align-items-center justify-end px-2 flex-shrink-0"
        >
          <v-btn
            class="mx-2 rounded-btn"
            color="background"
            elevation="0"
            @click="fontReset"
          >
            <v-icon
              small
              class="text"
            >
              mdi-reload
            </v-icon>
            <span class="accessible">Resetar fonte</span>
          </v-btn>
          <v-btn
            class="mx-2 rounded-btn"
            color="background"
            elevation="0"
            @click="fontResizeMinus"
          >
            <v-icon
              small
              class="text"
            >
              mdi-minus
            </v-icon>
            <span class="accessible">Diminuir fonte</span>
          </v-btn>
          <v-btn
            class="mx-2 rounded-btn"
            color="background"
            elevation="0"
            @click="fontResizePlus"
          >
            <v-icon
              small
              class="text"
            >
              mdi-plus
            </v-icon>
            <span class="accessible">Aumentar fonte</span>
          </v-btn>
          <v-btn
            class="mx-2 rounded-btn"
            color="background"
            elevation="0"
            @click="darkMode"
          >
            <v-icon
              small
              class="text"
            >
              mdi-eye
            </v-icon>
            <span class="accessible">Contraste</span>
          </v-btn>
        </v-flex>
      </nav>
    </div>
    <div v-if="this.$store.state.showAlertManyVotes">
      <nav class="d-flex flex-row justify-start align-center py-2 px-8">
        <v-flex
          xs1
          class="d-none d-sm-flex flex-row px-2 flex-shrink-0"
        />
        <v-flex
          xs12
          sm10
          class="d-flex flex-row px-2 flex-shrink-0 align-items-center justify-center"
        >
          <v-row class="alertManyVotes align-center">
            <v-col
              cols="2"
              class="text-center"
            >
              <v-icon
                class="custom-icon warning--text"
              >
                mdi-alert-outline
              </v-icon>
            </v-col>
            <v-col cols="10">
              <p
                v-html='msgAlert'
              />
            </v-col>
          </v-row>
        </v-flex>
        <v-flex
          class="d-flex align-items-center justify-start"
          v-if="isAuthenticated && !isAuthenticated"
        />
        <v-flex
          xs1
          v-if="accessibilityActivated"
          class="d-none d-sm-flex flex-row align-items-center justify-end px-2 flex-shrink-0"
        />
      </nav>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import util from '@/utils/util';
import service from '../services/election.service';
export default {
  data() {
    return {
      ok: false,
      drawer: false,
      items: [
        {
          icon: 'home',
          title: 'Início',
          to: 'Login'
        },
        {
          icon: 'person',
          title: 'Autentição',
          to: 'Login'
        },
        {
          icon: 'person',
          title: 'Cadastro Eleitor',
          to: 'CadastroEmail'
        },
        {
          icon: 'email',
          title: 'Reenvio de E-mail',
          to: 'ReenvioEmail'
        }
      ],
      model: 1,
      accessibilityActivated: true,
      windowEvents: {
        RESIZE: 'resize'
      },
      electionLogo: null,
      secretaryLogo: null,
      status: 'warning',
      msgAlert: 'Seu voto será registrado somente <u>após o término da votação em todos os cargos ou segmentos desta eleição</u>.<br /> <b>Certifique-se de concluir todos os seus votos.</b>'
    };
  },
  computed: {
    ...mapGetters('login', ['isAuthenticated'])
  },
  mounted() {
    this.verifyDisplay();
    this.$store.state.logout = this.logout;
    const showAlertManyVotes = ((!isNaN(this.$store.state.election.votesPerVoter) && (this.$store.state.election.votesPerVoter > 1)) || (this.$store.state.election.candidate_roles_total > 1)) && this.$store.state.election.currentState === 'VOTING';
    this.$store.commit('setShowAlertManyVotes', showAlertManyVotes);
    window.addEventListener(this.windowEvents.RESIZE, this.resizeMethod);
  },
  beforeDestroy() {
    window.removeEventListener(this.windowEvents.RESIZE, this.resizeMethod);
  },
  created() {
    const CreatedelementHTML = document.getElementsByTagName('html');
    CreatedelementHTML[0].style.fontSize = '16px';
    this.loadDataElection();
  },
  methods: {
    logout() {
      this.$store.state.login.electionName = '';
      this.$store.state.loginCurrentStatePage = '';
      this.$store.dispatch('login/logout').then(() =>
        this.$router.push(
          '/Election',
          () => {},
          () => {}
        )
      );
    },
    darkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
    fontResizePlus() {
      const elementHTML = document.getElementsByTagName('html');
      const actualSize = parseInt(elementHTML[0].style.fontSize);
      if (actualSize) {
        elementHTML[0].style.fontSize = actualSize + 1 + 'px';
      }
    },
    fontResizeMinus() {
      const elementHTML = document.getElementsByTagName('html');
      const actualSize = parseInt(elementHTML[0].style.fontSize);
      if (actualSize) {
        elementHTML[0].style.fontSize = actualSize - 1 + 'px';
      }
    },
    fontReset() {
      const elementHTML = document.getElementsByTagName('html');
      elementHTML[0].style.fontSize = '16px';
    },
    resizeMethod() {
      setTimeout(this.verifyDisplay, 300);
    },
    verifyDisplay() {
      const result = util.isMobile();
      this.accessibilityActivated = !result;
    },
    async loadDataElection() {
      const self = this;
      await service.getElections('').then(res => {
        if (res.data) {
          self.electionLogo = res.data.electionLogo;
          self.secretaryLogo = res.data.secretaryLogo;
          const showAlertManyVotes = (!isNaN(this.$store.state.election.votesPerVoter) && (this.$store.state.election.votesPerVoter > 1)) || (!isNaN(res.data.candidate_roles_total) && (res.data.candidate_roles_total > 1));
          self.$store.commit('setShowAlertManyVotes', showAlertManyVotes);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none !important;
}
.v-btn .accessible {
  font-size: 0.01rem;
  color: transparent;
  position: absolute;
}

.logoSize {
  width: 80px;
  height: 80px;
  /* padding: 10px; */
  border-radius: 20px;
}

.font_dark {
  color: #ffffff;
}

.font_white {
  /* color: #425e94 !important; */
  color: #ffffff !important;
}

.voterNameMenu {
  font-size: 16px;
  font-style: italic;
  font-weight: lighter;
}

.alertManyVotes {
  border-radius: 5px;
  padding: 0px 5px 0px 5px;
  border-style: solid;
  border-color: #FFC107 !important;
}

.alertManyVotes  > p{
  color: #ffffff;
  text-align: center;
}

.custom-icon {
  font-size: 3.2em !important;
}

.rounded-btn {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  min-width: 36px !important;
}
</style>
